import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthOrRedirect } from "./components/auth/redirect";
// Import build tool generated manifest file
import arbManifest from "../public/translations/arbManifest";
import { createAsyncMessageBundleManager, LocalizationContextBuilder } from "@amzn/arb-tools";
import { MbmProvider } from "@amzn/react-arb-tools";
import { getCurrentLocale } from "./helpers/utils";
import { Provider } from "react-redux";
import { setupStore } from "./reduxStore/store";

async function main() {
  // register msw to mock browser api
  if (process.env.NODE_ENV === "development") {
    if (window.location.pathname === "/checklist") {
      window.location.pathname = "/checklist/";
      return;
    }

    const { worker } = require("./mocks/browser");

    await worker.start({
      serviceWorker: {
        url: "/checklist/mockServiceWorker.js",
      },
    });
  }

  const store = setupStore({});

  // Define a localization context provider
  const localizationContextProvider = () =>
    new LocalizationContextBuilder().withLocale(getCurrentLocale()).withDefaultLocale("en-US").build();

  const mbm = createAsyncMessageBundleManager({
    arbManifest,
    localizationContextProvider,
    resolveBundleUrl: (url: string | undefined) =>
      url ? "/checklist/translations/" + url : "/checklist/translations/translation.json",
  });

  ReactDOM.render(
    <Provider store={store}>
      <MbmProvider mbm={mbm}>
        <React.StrictMode>
          <AuthOrRedirect>
            <App />
          </AuthOrRedirect>
        </React.StrictMode>
      </MbmProvider>
    </Provider>,
    document.getElementById("ASHContentRoot")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals(console.log);
}

main();
